export default __webpack_public_path__ + "static/media/theme-light.ee2f73d4.jpg";